import { render } from "./BoardMarquee.vue?vue&type=template&id=14386e20&scoped=true&ts=true"
import script from "./BoardMarquee.vue?vue&type=script&lang=ts"
export * from "./BoardMarquee.vue?vue&type=script&lang=ts"

import "./BoardMarquee.vue?vue&type=style&index=0&id=14386e20&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/vars.autocall.ai/vars.autocall.ai/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14386e20"]])

export default __exports__